<div style="display:none;">
  value is :{{value}}
  and item.value is{{item?.value}}
</div>
<div *ngIf="item.show || conditionMet">
  <app-rendered
    [childview]="item.childview || childview"
    [paramprefix]="item.paramprefix"
    [info]="info" *ngFor="let it of item.content"
    [item]="it" [arr]="item.content">
<!--    [data]="data" (setDisplay)="setDispalyItem($event)"-->
<!--    (deleteDataEvent)="delete($event)"-->
<!--    (openViewEvent)="openView($event)"-->
<!--    (moveHandler)="openMove()"-->
<!--    (openLinkEvent)="openLink($event)" >-->
  </app-rendered>
</div>
